export const iconFontAwesomeArrowsArrowRotateRight = (
	<i className="fa-solid fa-arrow-rotate-right"></i>
);
